import { render, staticRenderFns } from "./card-order-list.vue?vue&type=template&id=afa240e4&scoped=true&"
import script from "./card-order-list.vue?vue&type=script&lang=js&"
export * from "./card-order-list.vue?vue&type=script&lang=js&"
import style0 from "./card-order-list.vue?vue&type=style&index=0&id=afa240e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa240e4",
  null
  
)

export default component.exports